import { UnitTypeShort } from 'dayjs';

/**
 * tool to add !important to css stylings
 */
export const importantCSS = (css: string | number) => `${css} !important`;

export const monthsMap = {
  january: 'ינואר',
  february: 'פברואר',
  march: 'מרץ',
  april: 'אפריל',
  may: 'מאי',
  june: 'יוני',
  july: 'יולי',
  august: 'אוגוסט',
  september: 'ספטמבר',
  october: 'אוקטובר',
  november: 'נובמבר',
  december: 'דצמבר',
};

export const getTimeUnitHebrew = (timeUnit: UnitTypeShort, count: number) => {
  const isMulti = count > 1;
  // "d" | "D" | "M" | "y" | "h" | "m" | "s" | "ms"
  switch (timeUnit) {
    case 'd':
      return isMulti ? 'ימים' : 'יום';
    case 'D':
      return isMulti ? 'ימים' : 'יום';
    case 'M':
      return isMulti ? 'חודשים' : 'חודש';
    case 'y':
      return isMulti ? 'שנים' : 'שנה';
    case 'h':
      return isMulti ? 'שעות' : 'שעה';
    case 'm':
      return isMulti ? 'דקות' : 'דקה';
    case 's':
      return isMulti ? 'שניות' : 'שניה';
    case 'ms':
      return isMulti ? 'מילישניות' : 'מילישניה';
  }
};

// Format a number using fixed-point notation. The number of decimals can be specified.
export const formatFixed = (val: number, decimals: number): number => {
  const multiplier = Math.pow(10, decimals);
  return Math.round(val * multiplier) / multiplier;
};

// Separate number digits using comma separator (e.g. 1,234,567)
const commaSeparateNumber = (val: number) => {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Centralized number formatter
export const formatNumber = (
  value: number | null,
  decimals: number = 0,
  scale: number = 1,
): string => {
  if (value === null) {
    return '-';
  }
  const scaledVal = value * scale;
  const formattedVal = formatFixed(scaledVal, decimals);
  return commaSeparateNumber(formattedVal);
};
